function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.007 1.74c4.8-.065 9.028 7.9 8.992 21.265.37.31.6.784.6 1.305a1.693 1.693 0 01-3.385 0c0-.485.201-.926.529-1.234.035-10.05-3.35-19.078-6.736-19.078-3.385 0-6.77 9.027-6.736 19.078.328.308.53.749.53 1.234a1.693 1.693 0 01-3.386 0c0-.521.23-.994.6-1.305C17.978 9.64 22.133 1.807 27.006 1.74z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.189 15.84h7.053v38.368H11.773V15.84h7.053M20.942 15.84h12.131"
}));

var SvgBag = function SvgBag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bag.e13b7e1b.svg";
export { ForwardRef as ReactComponent };